import { trackEvent, reset, identifyUser, trackUsersSubscriptionStatus as trackUsersSubscriptionStatusWithSegment } from "services/frontend/Segment";
import { ApiCategory, getCategoryId } from "data/api/ApiCategory";

export const eventNames = {
         clickedHeroCTA: "Clicked Hero CTA",
         startedFreeTrial: "Started Free Trial",
         restartedSubscription: "Restarted Subscription",
         viewedArticle: "Viewed Article",
         viewedSubscriptionPage: "Viewed Subscription Page",
         clickedResubscribeFromPaywall: "Clicked Resubscribe on Paywall",
         clickedSubscribeOnPaywall: "Clicked Subscribe on Paywall",
         submittedSignupForm: "Submitted Signup Form",
         submittedResubscribeForm: "Submitted Resubscribe Form",
         submittedGiftForm: "Submitted Gift Form",
         sentGift: "Sent Gift",
         userRatedStory: "User Rated Story",
         userSearchedForStory: "User Searched For Story",
         identifiedSubscriptionStatus: "Identified Subscription Status",
         subscribedToNewsletter: "Subscribed to Newsletter on Newsletter Page"
       };


export function trackClickedHeroCTA() {
    trackEvent(eventNames.clickedHeroCTA)
}

export function trackIdentifiedSubscriptionStatus() {
    trackEvent(eventNames.identifiedSubscriptionStatus);
}

export function identifyUserToAnalytics(userFirebaseId: string, userEmail: string) {
    identifyUser(userFirebaseId, userEmail);
}

export function trackUsersSubscriptionStatus(userIsSubscriber: boolean) {
    trackUsersSubscriptionStatusWithSegment(userIsSubscriber);
}

export function resetAnalytics() {
    reset()
}

export function trackStoryRating(storyId: string, storyRating: string, authorId: string, categories: ApiCategory[]) {
    trackEvent(eventNames.userRatedStory, {
      storyId,
      storyRating,
      authorId,
      categoryIds: categories.map(category => getCategoryId(category)).join(' ')
    });
}

export function trackUserSearchedForStory(searchString: string) {
    trackEvent(eventNames.userSearchedForStory, {
        searchString
    })
}

export function trackStoryView(storyId: string, authorId: string) {
    trackEvent(eventNames.viewedArticle, {
        article_id: storyId,
        authorId
    })
}

export function trackResubscribeClickOnStoryPaywall(storyId: string) {
    trackEvent(eventNames.clickedResubscribeFromPaywall, {
		article_id: storyId
	});
}

export function trackSubscribeClickOnStoryPaywall(storyId: string, authorId: string) {
    trackEvent(eventNames.clickedSubscribeOnPaywall, {
        article_id: storyId,
        authorId
    })
}

export function trackRestartedSubscription(planId: string) {
    trackEvent(eventNames.restartedSubscription, {
        planId
    })
}

export function trackSubmittedSignupForm() {
    trackEvent(eventNames.submittedSignupForm)
}

export function trackSubmittedResubscribeForm() {
  trackEvent(eventNames.submittedResubscribeForm);
}

export function trackSubmittedGiftForm() {
    trackEvent(eventNames.submittedGiftForm)
}

export function trackViewedSubscriptionPage() {
    trackEvent(eventNames.viewedSubscriptionPage)
}

export function trackStartedFreeTrial(planId: string) {
  trackEvent(eventNames.startedFreeTrial, { planId });
}